import React from "react"
import PropTypes from "prop-types"
import CustomerPanel from "@/business-components/sale/customers/CustomerPanel"
import AccountPanel from "@/business-components/sale/customers/AccountPanel"
import ActionRecordPanel from "./actionRecords/ActionRecordPanel"
import DockedDialog from "@/components/DockedDialog"
import ContactPanel from "@/business-components/sale/customers/ContactPanel"
import LeadReplenish from "@/business-components/sale/customers/LeadReplenish"
import { withApi } from "@tencent/react-aio"
import * as ActionTypes from "@/stores/sale/actions"
import { connect } from "react-redux"
import { isContain } from "@/utils/ParamUtils"
import fePerms from "@/common/permissions/sale/fePerms"
import MessageBox from "@/components/MessageBox"
import { getQuery } from "@/utils"

class LeadDetails extends React.Component {
  static propTypes = {
    // show: PropTypes.bool,
    // onClose: PropTypes.func,
    // onSubmit: PropTypes.func,
    // onCancel: PropTypes.func,
    match: PropTypes.shape({
      params: PropTypes.shape({
        leadId: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
    history: PropTypes.object.isRequired,
    lead: PropTypes.object,
  }

  state = {}

  componentDidMount() {
    this.fetchLead()
  }

  fetchLead = () => {
    const {
      webApi,
      id,
    } = this.props;
    const leadId = this.props.match?.params?.leadId || id;
    const agencyId = getQuery("agencyId")
    webApi
      .getLead(leadId, agencyId)
      .dispatchJson(ActionTypes.FETCH_LEAD)
      .then((res) => {
        this.setState({ lead: { ...res } });
      })
      .catch((error) => {
        this.context.error("获取线索信息失败", error.message)
      })
  }

  render() {
    const { hide } = this.props;
    // const leadId = parseInt(params.leadId);
    const { lead } = this.state
    if (!lead) {
      return null
    }
    // 是否可以编辑
    const readOnly = !isContain(lead.permissions, fePerms.LEAD_EDIT)

    return (
      <DockedDialog show={!hide} className="LeadDetails" title="线索详情" escHide={true} cancelButton={false} submitLabel={"关闭"} onSubmit={this.handleSubmit} onClose={this.handleClose} onCancel={this.handleClose}>
        {this.renderCustomerInfo(lead, readOnly)}
        {this.renderLeadReplenish(lead, readOnly)}
        {this.renderContactList(lead, readOnly)}
        {this.renderAccountInfo(lead)}
        {this.renderActionRecordList(lead, readOnly)}
      </DockedDialog>
    )
  }

  renderCustomerInfo(lead, readOnly) {
    return <CustomerPanel showCheckNewCustom detail={{...lead, lead: lead}} isLead ascriptionOwnerId={lead.ownerId} ascriptionTeamId={lead.leadAscriptionTeamId} lead={lead} readOnly={readOnly} onEdit={this.handleEdit} callback={this.fetchLead} />
  }

  renderLeadReplenish(lead, readOnly) {
    return <LeadReplenish detail={{...lead, lead: lead}}/>
  }

  renderContactList(lead, readOnly) {
    return <ContactPanel secure={location.pathname.indexOf("seas") > -1} isLead lead={lead} readOnly={true} getDetail={this.fetchLead} editPerm={!readOnly} />
  }

  renderAccountInfo(lead) {
    return <AccountPanel detail={{...lead, lead: lead}} isLead lead={lead} callback={this.fetchLead} supportWx/>
  }

  renderActionRecordList(lead, readOnly) {
    return <ActionRecordPanel isLead lead={lead} readOnly={readOnly} onChange={this.fetchLead} />
  }

  handleEdit = () => {
    const { history } = this.props
    const pathname = history.location.pathname
    history.push({ pathname: pathname + "/edit" })
  }

  handleSubmit = () => {
    this.handleClose()
  }

  handleClose = () => {
    if (this.props.handleClose) {
      return this.props.handleClose();
    }
    const { history } = this.props
    const pathname = history.location.pathname
    history.push({ pathname: pathname.substr(0, pathname.lastIndexOf("/")) })
  }
}

function mapStateToProps(state, ownProps) {
  const {
    id,
  } = ownProps;
  const leadId = ownProps.match?.params?.leadId || id;
  return {
    lead: state.leadRepo[leadId || id],
  }
}

export default withApi(connect(mapStateToProps)(LeadDetails))

LeadDetails.contextType = MessageBox
